export const BUDGET_LINKAGE_REQUEST = 'BUDGET_LINKAGE_REQUEST';
export const BUDGET_LINKAGE_SUCCESS = 'BUDGET_LINKAGE_SUCCESS';
export const BUDGET_LINKAGE_FAIL = 'BUDGET_LINKAGE_FAIL';